import React, { useEffect, useState } from 'react'
import utils from '../../utils'
import CustomerProfile from './CustomerProfile'
import toast from 'react-hot-toast'
import DeliveryDetails from './DeliveryDetails'
import { useLoadScript } from '@react-google-maps/api'
import { useCart } from '../../context/CartContext'
import cartServices from '../../services/CartServices'
import FormError from '../feedback/FormError'
import paymentsService from '../../services/PaymentServices'
import { FaArrowLeftLong } from 'react-icons/fa6'
import { Link } from 'react-router-dom'
import { useAuth } from '../../context/UserContext'

const libraries = ["places"];

function DeliveriInfoStage({ cart, totalPrice, numCartItems, setStage, setCart }) {
    const [error, setError] = useState()
    const {
        customerProfile,
        setCustomerProfile,
        deliveryDetails,
        setDeliveryDetails,
        payment,
        setPayment
    } = useCart()
    const [loading, setLoading] = useState(false)
    const [profile, setProfile] = useState()
    const [delivery, setDelivery] = useState()

    const { isAuth, user } = useAuth()
    useEffect(() => {
        if (isAuth && user && !profile) {
            setProfile({
                email: user?.email,
                full_name: user?.full_name || ''
            })

        }
    }, [isAuth, user, profile])

    useEffect(() => {
        if (!payment || !cart?.cart_data) return;

        const cartTotal = parseFloat(cart.cart_data.total);
        const paymentItemsTotal = parseFloat(payment.items_total);

        if (Math.abs(cartTotal - paymentItemsTotal) > 0.01) {
            let isUpdating = false;

            if (!isUpdating) {
                isUpdating = true;
                paymentsService.updatePayment(payment.id).then(
                    (res) => {
                        setPayment(res.data);
                        isUpdating = false; // reset
                    },
                    (err) => {
                        console.log(err);
                        isUpdating = false;
                    }
                );
            }
        }
    }, [cart, payment, payment?.id, setPayment]);


    useEffect(() => {
        if (deliveryDetails) {
            setDelivery(deliveryDetails)
        }
    }, [deliveryDetails])
    useEffect(() => {
        if (customerProfile) {
            setProfile(customerProfile)
        }
    }, [customerProfile])

    const { isLoaded } = useLoadScript({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
        libraries,
        id: 'google-maps-script',
        async: true,
        defer: true,
    });

    async function createDeliveryDetails() {
        setLoading(true);
        setError(null);

        try {
            const addRes = await cartServices.addDelivery(delivery);

            setDeliveryDetails(addRes.data?.cart_data?.delivery);
            const cartRes = await cartServices.checkCart();
            setCart(cartRes.data);

        } catch (err) {
            let errorMessage = 'Something went wrong';

            if (err.response?.status === 400 && Array.isArray(err.response.data?.details)) {
                const messages = err.response.data.details.map(d => {
                    const fieldName = d.field
                        ? d.field.charAt(0).toUpperCase() + d.field.slice(1)
                        : 'Field';
                    return `${fieldName}: ${d.message}`;
                });
                errorMessage = messages.join('; ') || 'Validation failed';

            } else if (err.response?.status === 400 && err.response.data) {
                const data = err.response.data;
                const fieldErrors = Object.entries(data)
                    .flatMap(([field, msgs]) =>
                        (Array.isArray(msgs) ? msgs : [msgs])
                            .filter(msg => typeof msg === 'string')
                            .map(
                                msg =>
                                    `${field.charAt(0).toUpperCase() + field.slice(1)}: ${msg}`
                            )
                    );
                errorMessage = fieldErrors.join('; ') || 'Invalid input';

            } else if (err.request) {
                errorMessage = 'Network error — please check your connection';

            } else {
                errorMessage = err.message || 'Something went wrong';
            }

            setError(errorMessage);

        } finally {
            setLoading(false);
        }
    }


    function createCustomerProfile() {
        paymentsService.createCustomer(profile).then(
            res => {
                setCustomerProfile(res.data)
                const customerId = res?.data?.id
                const cartId = cart?.cart_id
                const data = {
                    "customer_profile": customerId,
                    "cart": cartId
                }
                paymentsService.requestCartPayment(data).then(
                    res => {
                        setPayment(res.data)
                        setLoading(false)
                    },
                    err => {
                        console.log(err);

                        setLoading(false)
                        setError(err)
                    }
                )
            },
            err => {
                console.log(err);
                setLoading(false)
                setError(err)
            }
        )
    }

    function processDelivery() {
        setError()
        if (!profile?.email || !profile?.full_name) {
            toast.error("Email and Full Name are required")
            return
        }
        if (!delivery?.city || !delivery?.street) {
            toast.error("City and Street Address are required")
            return
        }
        setLoading(true)
        if (!deliveryDetails) {
            createDeliveryDetails()
        } else {
            console.log("deets");

        }
        if (!customerProfile) {
            createCustomerProfile()
        }
        setStage(1)
    }
    return (
        <div className="flex flex-col lg:flex-row gap-8">
            <div className="w-full lg:w-2/3">
                <p className='mb-6'>Enter your Delivery Details to continue</p>
                {error && (
                    <FormError error={error} />
                )}
                <div className='space-y-5'>
                    <CustomerProfile
                        profile={profile}
                        setProfile={setProfile}
                    />
                    <DeliveryDetails
                        delivery={delivery}
                        setDelivery={setDelivery}
                        isLoaded={isLoaded}
                    />
                </div>
            </div>

            {/* Order Summary (Sticky) */}
            <div className="w-full lg:w-1/3">
                <div className="bg-white dark:bg-card-dark rounded-xl shadow-md border border-border-light dark:border-border-dark p-6 sticky top-6">
                    <h2 className="text-lg font-bold text-gray-900 dark:text-white border-b border-border-light dark:border-border-dark pb-4 mb-4">
                        Order Summary
                    </h2>

                    <div className="space-y-3 mb-6">
                        <div className="flex justify-between">
                            <span className="text-gray-600 dark:text-gray-400">Subtotal ({numCartItems} item{numCartItems !== 1 ? 's' : ''})</span>
                            <span className="font-medium">KSH {utils.toCommas(payment?.items_total || totalPrice)}</span>
                        </div>
                        <div className="flex justify-between">
                            <span className="text-gray-600 dark:text-gray-400">Delivery</span>
                            <span className="font-medium">{payment?.delivery_total || 0}</span>
                        </div>
                        <div className="flex justify-between pt-2 border-t border-border-light dark:border-border-dark">
                            <span className="font-bold text-lg">Total</span>
                            <span className="font-bold text-lg text-secondary">KSH {utils.toCommas(payment?.total || totalPrice)}</span>
                        </div>
                    </div>

                    <button
                        type="button"
                        onClick={processDelivery}
                        disabled={loading} // ← key: disable while loading
                        className={`w-full font-bold py-3 px-4 rounded-lg text-center transition shadow-md
                        ${loading
                                ? 'bg-gray-400 text-gray-200 cursor-not-allowed'
                                : 'bg-secondary text-white hover:bg-orange-600 cursor-pointer'
                            }`}
                    >
                        {loading ? 'Loading...' : 'Go to Payment'}
                    </button>
                    <Link
                        to={'/cart'}
                        className='btn btn-ghost text-primary w-full mt-2'>
                        <FaArrowLeftLong /> Go to Cart
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default DeliveriInfoStage